import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Box, Typography, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore, } from '@mcn-platform/models';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
import PlaceHolder from '../common/PlaceHolder';
import CustomButton from '../common/CustomButton';
import Question from './Question';
const findQuestionnaire = async (store, email) => {
    const questionnaires = await store.listQuestionnairesByEmail(email);
    // console.log('Found questionnaires', questionnaires);
    return questionnaires[0];
};
const QuestionnaireWidget = ({ questionnaireID, backgroundColor, readonly, editData, }) => {
    const [questionnaire, setQuestionnaire] = useState();
    const store = useStore();
    const currentEmail = store.currentCustomer?.email;
    useEffect(() => {
        if (questionnaireID === '.checkByEmail') {
            // look up and set the questionnaire based on the email
            console.log('Check by email', currentEmail);
            const questionnaires = findQuestionnaire(store, currentEmail).then((q) => {
                setQuestionnaire(q);
            });
        }
        else if (questionnaireID) {
            setQuestionnaire(store.getOrLoad('questionnaire', questionnaireID));
        }
        else {
            setQuestionnaire(undefined);
        }
    }, [questionnaireID, currentEmail, store]);
    const handleSubmit = () => {
        questionnaire?.updateValues({
            status: 'complete',
        });
        store.update('questionnaire', questionnaire);
    };
    if (!questionnaire) {
        return _jsx("div", { children: "\u00A0" });
    }
    if (!questionnaireID) {
        if (editData) {
            return (_jsx(PlaceHolder, { placeHolderName: "Configure Questionnaire Widget" }));
        }
        return null; // no course - silently skip the widget
        // return (<div>No featured course</div>);
        // @todo - when editing show placeholder
    }
    if (editData && questionnaireID === '.checkByEmail') {
        return (_jsx(PlaceHolder, { placeHolderName: "Display Questionnaire Assigned By Customer Email" }));
    }
    if (!readonly && questionnaire.status === 'complete') {
        if (questionnaire.completionMessage?.slate) {
            return (_jsx(WysiwygViewer, { id: questionnaire.id, value: questionnaire.completionMessage.slate }));
        }
        return (_jsx(Typography, { variant: "h3", children: "Thank you for completing the questionnaire." }));
    }
    return (_jsxs(Box, { sx: { background: backgroundColor || 'inherit' }, children: [_jsx(Typography, { variant: "h2", sx: { mb: 4 }, children: questionnaire.name }), questionnaire.welcomeMessage?.slate && (_jsx(WysiwygViewer, { id: questionnaire.id, value: questionnaire.welcomeMessage.slate })), questionnaire.questions?.map((question) => (_jsx(Question, { question: question, setResponse: (response) => {
                    questionnaire.recordResponse(question, response);
                }, readonly: readonly }, question.id))), !readonly && (_jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'start',
                    my: 4,
                }, children: _jsx(CustomButton
                // className="site-system-button-primary"
                , { 
                    // className="site-system-button-primary"
                    onClick: handleSubmit, label: "Submit Questionnaire", customStyle: { maxWidth: '300px' } }) }))] }));
};
QuestionnaireWidget.defaultProps = {
    readonly: false,
    editData: undefined,
    backgroundColor: undefined,
};
QuestionnaireWidget.meta = {
    group: 'account',
    name: 'Questionnaire',
    description: 'Displays the questionnaire to the customer.',
    props: [
        {
            key: 'questionnaireID',
            returnId: true, // hack to to make the picker return the course ID
            name: 'Questionnaire',
            type: 'questionnaire',
            description: 'The questionnaire being given.',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'QuestionnaireWidget',
        props: {
            courseID: '@questionnaireID',
        },
    },
};
export default observer(QuestionnaireWidget);
//# sourceMappingURL=QuestionnaireWidget.js.map